import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { reservationsApi, ApiError } from '../services/api';
import type { CreateReservationRequest, SlotId } from '@cp-parkingslots/shared';

export function useReservations(startDate: string, endDate: string, slotId?: SlotId) {
  return useQuery({
    queryKey: ['reservations', startDate, endDate, slotId],
    queryFn: () => reservationsApi.getReservations(startDate, endDate, slotId),
    enabled: !!startDate && !!endDate,
  });
}

export function useCreateReservation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateReservationRequest) =>
      reservationsApi.createReservation(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reservations'] });
    },
    onError: (error: ApiError) => {
      console.error('Failed to create reservation:', error);
    },
  });
}

export function useDeleteReservation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => reservationsApi.deleteReservation(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reservations'] });
    },
    onError: (error: ApiError) => {
      console.error('Failed to delete reservation:', error);
    },
  });
}
